





















import { Component } from 'vue-property-decorator';
import { Discount } from '../store/modules/discounts';
import DiscountBanners from './DiscountBanners.vue';

@Component
export default class TourDiscountBanners extends DiscountBanners {
    protected get filteredDiscounts(): Discount[] {
        return this.discounts.filter((discount) => {
            return discount.bannerSettings.enabled &&
                    discount.name.length > 0 &&
                    discount.comment.length > 0;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TourDiscountBanners.vue